import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.scss'

class Collapse extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: props.isExpanded,
    }
  }

  handleClick = () => {
    const isExpanded = !this.state.isExpanded
    if (this.props.trackToggle) {
      analyticsUtils.gaTagTracking({
        event: this.props.analyticsEvent,
        eventCategory: analyticsUtils.categories.PRODUCT_FILTER,
        eventAction: this.props.analyticsEventAction,
        eventLabel: isExpanded ? 'Open' : 'Close',
      })
    }
    this.setState({ isExpanded })
  }

  render() {
    const { isExpanded } = this.state
    const { className, headerClassName, children, heading } = this.props

    return (
      <div className={classNames(style.Collapse, className)}>
        <button
          className={classNames(style.heading, headerClassName)}
          aria-haspopup={!isExpanded}
          aria-expanded={isExpanded}
          onClick={() => this.handleClick()}
        >
          <div className={style.collapseHeader}>
            {heading}

            <Icon
              type={isExpanded ? 'chevron-up' : 'chevron-down'}
              size="small"
              className={style.chevron}
            />
          </div>
        </button>

        <div
          className={classNames(style.childrenWrap, {
            [style.expanded]: isExpanded,
          })}
        >
          {children}
        </div>
      </div>
    )
  }
}

Collapse.propTypes = {
  heading: PropTypes.string,
  headerClassName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  isExpanded: PropTypes.bool,
  analyticsEvent: PropTypes.string,
  analyticsEventAction: PropTypes.string,
  trackToggle: PropTypes.bool,
}

Collapse.defaultProps = { isExpanded: false, trackToggle: true }

export default Collapse
